import Fetch from 'jsx/common/util/_fetch';
type RequestRemoteBody = {
  asset: string;
  protocol: string;
  ticket_id: string;
  request_message: string;
  dateRange: any[];
};

export const request = async (body: RequestRemoteBody) => {
  const [approved_start_date = null, approved_end_date = null] = body.dateRange;

  const sanitizedValues: any = {
    ...body,
    approved_start_date: approved_start_date,
    approved_end_date: approved_end_date,
  };

  delete sanitizedValues.dateRange;

  return Fetch.post(`/api/remote-request/`, {
    method: 'POST',
    body: JSON.stringify(sanitizedValues),
  });
};
